export default "__VITE_ASSET__D8G3srqz__"